module.exports = __webpack_public_path__ + "static/media/a-5.c52409a1.jpg";